module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_a-function.js